import React from 'react'
import classnames from 'classnames'

import { useIsParticipantMobileInFloor } from '../../../../firebase/hooks/useFloor'
import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useParticipant } from '../../../../webrtc/webRTCRoom'

interface FloorCameraFeedProps {
  id: number
}

const FloorMobileFeed = ({ id }: FloorCameraFeedProps) => {
  const isParticipantMobileInFloor = useIsParticipantMobileInFloor(id)
  const participant = useParticipant(id)

  if (!participant?.tracks.mobile) return null

  return (
    <div
      className={classnames('participant-mobile-track', {
        hide: !isParticipantMobileInFloor,
      })}
    >
      <VideoTrack track={participant.tracks.mobile} objectFit="contain" />
    </div>
  )
}

export { FloorMobileFeed }
